export default __webpack_public_path__ + "static/media/impact6.82eb36a9.jpg";